import React from 'react';
import './room-join.css';
import socketService from "../../services/socket";
import Options from "../../components/options/options";
import Modal from "../../components/modal/modal";
import TextInput from "../../components/text-input/TextInput";
import Button from "../../components/button/button";

function RoomJoin({setRoomWant, roomWant, setShowModal, showModal, stepPlayer, setStepPlayer}) {
    return (
        <div className="room-join">
            {stepPlayer === 'stepConnection' &&
                <div className={'alert'}>
                    Aguarde outras pessoas conectarem na sala
                </div>
            }
            <div className={'options-data'}>
                <Options method={() => {
                    socketService.emit('createRoom', '');
                    setStepPlayer('stepConnection');
                }}>
                    Criar uma nova sala
                </Options>

                <Options method={() => setShowModal(true)}>
                    Entrar em sala já existente
                </Options>
                <Modal methodButton={() => {
                }} hidden={!showModal} setShowModal={setShowModal}>
                    <h3>Digite o ID da sala abaixo</h3>
                    <TextInput method={(event) => {
                        setRoomWant(event.target.value);
                    }}/>
                    <Button method={() => {
                        socketService.emit('joinRoom', roomWant);
                    }}>Entrar</Button>
                </Modal>
            </div>
        </div>
    );
}

export default RoomJoin;